'use strict';
//import * as momentTimezone from "moment-timezone";
/**
 * Filter demo (currently just used to define the module)
 */
angular.module('autoremind.filters', [])
    .filter('interpolate', [function () {
        return function (text) {
            return String(text).replace(/\%VERSION\%/mg, version);
        };
    }]);
angular.module('autoremind').filter('newline2br', function () {
    return function (text) {
        return text.replace(/\n/g, '<br/>');
    };
});
/**
 * Filter used to output profile name in the logs UI
 *
 * TODO: Consider moving this to a function in the logs controller
 */
angular.module('autoremind').filter('profileNameFilter', function () {
    return function (input) {
        if (input != "") {
            return "(" + input + ")";
        }
        return '';
    };
});
/**
 * Filter to convert an SQL timestamp string to a JavaScript Date.
 * Then this can be passed through angular's date formatting filters.
 */
angular.module('autoremind').filter('stringToDate', function () {
    return function (input) {
        // NOTE: This is using datejs (datejs.com) because JavaScrip's Date does not work with SQL dates on Safari and IE
        //return input.substr(0,19); // Make sure to get only 'yyyy-mm-dd hh:mm:ss' and nothing more
        return Date.parse(input.substr(0, 19)); // Make sure to get only 'yyyy-mm-dd hh:mm:ss' and nothing more
    };
});
// Source: https://github.com/petebacondarwin/angular-toArrayFilter
angular.module('autoremind').filter('toArray', function () {
    return function (obj, addKey) {
        if (!angular.isObject(obj))
            return obj;
        if (addKey === false) {
            return Object.keys(obj).map(function (key) {
                return obj[key];
            });
        }
        else {
            return Object.keys(obj).map(function (key) {
                var value = obj[key];
                return angular.isObject(value) ?
                    Object.defineProperty(value, '$key', { enumerable: false, value: key }) :
                    { $key: key, $value: value };
            });
        }
    };
});
angular.module('autoremind').filter('trustUrl', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }]);
angular.module('autoremind').filter('bytes', function () {
    return function (bytes, precision) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes))
            return '-';
        if (typeof precision === 'undefined')
            precision = 1;
        var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'], number = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
    };
});
// Milliseconds to date in selected timezone (not always browser's timezone)
// This will display timestamps correctly according to user's timezone
// including dates outside the current daylight settings
// Eg. in New York 11/19/2018 has offset -5h from UTC even when displayed
// on e.g. 03/09/2020 where the offset is -4h from UTC
angular.module('autoremind').filter('amTestFilter', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
        return function (value, format, preprocess) {
            if (typeof value === 'undefined' || value === null) {
                return '';
            }
            var timezone = angularMomentConfig.timezone;
            var date = amMoment.preprocessDate(value);
            if (!date.isValid()) {
                return '';
            }
            if (date.tz) {
                date = date.tz(timezone);
            }
            else {
                debugger;
                console.log('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
            }
            return date.format(format);
        };
    }]);
angular.module('autoremind').filter('amUTCFilter', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
        return function (value, format, preprocess) {
            if (typeof value === 'undefined' || value === null) {
                return '';
            }
            /*var strTz = $scope.selectedItem.value;
            //var tempDate = moment(value).tz(strTz);
            var tempDate = moment().tz(strTz);*/
            var timezone = 'UTC';
            /*
            if (aMoment && timezone) {
                    if (aMoment.tz) {
                            aMoment = aMoment.tz(timezone);
                    } else {
                            $log.warn('angular-moment: timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js?');
                    }
            }
            */
            var tempDate;
            if (!isNaN(parseFloat(value)) && isFinite(value)) {
                tempDate = moment(parseInt(value, 10));
            }
            else {
                tempDate = moment(value);
            }
            if (!tempDate.isValid()) {
                return '';
            }
            tempDate.tz(timezone);
            //var formattedTime = tempDate.format(format);
            var formattedTime = tempDate.format(format);
            return formattedTime;
            amMoment.applyTimezone(date).format(format);
            value = amMoment.preprocessDate(value, preprocess);
            var date = moment(value);
            if (!date.isValid()) {
                return '';
            }
            return amMoment.applyTimezone(date).format(format);
        };
    }]);
//# sourceMappingURL=autoremind.filters.js.map